import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 18 18" {...props}>
      <title id="Mute">{props.title || 'Mute'}</title>
      <g>
        <path
          d="M9 1L6.91 3.09 9 5.18V1zM1.27 0L0 1.27 4.73 6H0v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L16.73 18 18 16.73l-9-9L1.27 0zM16 9c0 .94-.2 1.82-.54 2.64l1.51 1.51C17.63 11.91 18 10.5 18 9c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zm-2.5 0c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63z"
          fillRule="evenodd"
        />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/mute.js